import React from "react";
import { Validation } from "./Validation";
import { Icon, Alert } from "@optimed/react";

interface ValidationViewProps {
  validations: Validation[];
}

export function ValidationView(props: ValidationViewProps) {
  if (!props.validations || props.validations.length === 0) return null;

  return (
    <Alert type="warning" className="mb-0">
      {props.validations.map(x => (
        <small key={x.title + x.message}>
          <div>
            <Icon icon="exclamation-triangle" /> <span className="font-weight-bold">{x.title}</span>
          </div>
          <span>{x.message}</span>
        </small>
      ))}
    </Alert>
  );
}
